import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { getStageTypeDisplay, getStageTimeLabel } from '../../lib/conventionResults';
import { stageEntries } from '../../lib/conventionKanban';
import StageCountdown from './stageCountdown';

// Keep showing a lag that has already started for a while, so the shooter still
// sees their start info while the lag is running (or until the admin marks it done).
const ONGOING_GRACE_MS = 2 * 60 * 60 * 1000;

// "Mitt neste lag" on the convention frontpage: the logged-in shooter's next
// upcoming (or currently running) lag with start time and shooter number.
// The shooter number is the participant's position on the lag — the same
// numbering as the printed scoresheet rows (stagesKanban).
@observer
class ConventionMyNextStage extends Component {
    render() {
        const { userStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const { convention } = this.props;

        if (!convention?.id || !user?.id) {
            return null;
        }

        const myStages = [];
        (convention.stages || []).forEach((stage, idx) => {
            const stageParticipants = convention[`participants${idx + 1}`] || [];
            const mine = stageEntries(stageParticipants).find(en => en.participant.id === user.id);
            if (mine) {
                myStages.push({ stage, shooterNumber: mine.position });
            }
        });

        const now = Date.now();
        const next = myStages
            .filter(({ stage }) => stage.date && !parseInt(stage.stageDone, 10))
            .filter(({ stage }) => new Date(stage.date).getTime() > now - ONGOING_GRACE_MS)
            .sort((a, b) => new Date(a.stage.date) - new Date(b.stage.date))[0];

        if (!next) {
            return null;
        }

        const { stage, shooterNumber } = next;

        return (<>
            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mb-1 mt-3'>
                <span>
                    <i class='fa-duotone fa-person-rifle me-2' />
                    <Text id='convention.my-next-stage'>My next squad</Text>
                </span>
            </div>
            <div class={`mt-0 mb-3 mx-3 px-3 py-2 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                <div class='d-flex justify-content-between align-items-center py-1'>
                    <span>
                        <i class='fa-duotone fa-flag-checkered me-2 text-primary' />
                        <strong>{stage.name}</strong>
                        <span class='text-body-secondary ms-1'>({getStageTypeDisplay(stage.type)})</span>
                    </span>
                    <StageCountdown date={stage.date} />
                </div>
                <div class='d-flex justify-content-between align-items-center py-1'>
                    <span class='text-body-secondary'>
                        <i class='fa-duotone fa-clock me-2' />
                        <Text id='convention.my-next-stage-start-time'>Start time</Text>
                    </span>
                    <span class='fw-bold'>{getStageTimeLabel(stage, convention)}</span>
                </div>
                <div class='d-flex justify-content-between align-items-center py-1'>
                    <span class='text-body-secondary'>
                        <i class='fa-duotone fa-hashtag me-2' />
                        <Text id='convention.my-next-stage-shooter-number'>Shooter number</Text>
                    </span>
                    <span class='fw-bold'>{shooterNumber}</span>
                </div>
            </div>
        </>);
    }
}

export default ConventionMyNextStage;
